import React,{useEffect,useState} from 'react';
import {Helmet} from "react-helmet";
import Header from "../../components/Header";
import ProductDetails from "../../components/ProductDetail";
import Footer from "../../components/Footer";
import ActiveCatalogue from '../../components/ActiveCatalogue/ActiveCatalogue'
import { useSelector, useDispatch } from 'react-redux'
import * as AuthVerify from '../../lib/common';
import './ProductDetail.styles.css'; 

const ProductDetail = () => {
	const productDetails = useSelector(state => state.productDetails);
	const dispatch = useDispatch();
	const [metaDetails, setMetaDetails] = useState(false);

	useEffect(() => {
		if(productDetails){
			AuthVerify.productDetails().then(data=>{
				setMetaDetails(data)
			})
		}
	  }, [productDetails])
	return (
		<div>
			<Helmet>
				{/* {metaDetails ? <> */}
				{/* <title>{metaDetails.matm.matname}</titlhe>
				<meta name="description" content={metaDetails.matm.description?.length>1?metaDetails?.matm.description:metaDetails?.matm.matname} />
				<meta property="og:image" content={metaDetails.matm.imageurl}/>
				<meta property="og:title" content={metaDetails.matm.matname}/>
				<meta name="title" content={metaDetails.matm.matname}/>
				<meta property="og:description" content={metaDetails.matm.description.length>1?metaDetails?.matm.description:metaDetails?.matm.matname} />*/}
				
				{/* <meta property="og:url" content="%PUBLIC_URL%"/>
				<title>{"metaDetails?.matm?.matname"}</title>
				<meta name="description" content="{metaDetails?.matm?.description?.length>1?metaDetails?.matm?.description:metaDetails?.matm?.matname}" />
				<meta name="title" content="{metaDetails?.matm?.matname}"/> 
				<meta property="og:image" content="{metaDetails?.matm?.imageurl}"/>
				<meta property="og:title" content="{metaDetails?.matm?.matname}"/>
				<meta property="og:description" content="{metaDetails?.matm?.description?.length>1?metaDetails?.matm?.description:metaDetails?.matm?.matname}" />
				 */}
				<title>Product Details</title>
			</Helmet>
			<Header/>
            <ActiveCatalogue/>
			<ProductDetails reducer={productDetails} dispatch={dispatch}/>
			<Footer/>
		</div>
	); 
}; 

export default ProductDetail;